export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51Pi4UVEbFTzTDLQ7NVhaMtvGkD7EGEgR30ouJkJ9EJwoAOiVo2Fy2y2MX3PijGX5yZEFX39fc3NsFSNJvAFngw2R00FAs0EEes';

// Stripe Price IDs for different credit packages
// You'll need to create these products/prices in your Stripe dashboard
export const STRIPE_PRICE_IDS = {
  single: 'price_1Rd4rQEbFTzTDLQ7S0JWnbKL', // $3 for 1 unlock
  pack5: 'price_1Rd4syEbFTzTDLQ7yCtrCnDd',        // $12 for 5 unlocks (20% off)
  pack10: 'price_1Rd4tdEbFTzTDLQ7Hs476bjy',      // $21 for 10 unlocks (30% off)
  pack25: 'price_1Rd4u9EbFTzTDLQ71RdvtAvt'       // $45 for 25 unlocks (40% off)
};

// Success URL - where users return after successful payment
export const SUCCESS_URL = window.location.origin + '/payment-success';
export const CANCEL_URL = window.location.origin;

// Credit packages configuration
export const CREDIT_PACKAGES = [
  { 
    id: 'single', 
    credits: 1, 
    price: 3, 
    savings: 0,
    popular: false 
  },
  { 
    id: 'pack5', 
    credits: 5, 
    price: 12, 
    savings: 20,
    popular: false 
  },
  { 
    id: 'pack10', 
    credits: 10, 
    price: 21, 
    savings: 30,
    popular: true 
  },
  { 
    id: 'pack25', 
    credits: 25, 
    price: 45, 
    savings: 40,
    popular: false 
  }
];